export const DADOS_ABERTOS = 'DADOS_ABERTOS';
export const DADOS_ABERTOS_START = 'DADOS_ABERTOS_START';
export const DADOS_ABERTOS_SUCCESS = 'DADOS_ABERTOS_SUCCESS';
export const DADOS_ABERTOS_ERROR = 'DADOS_ABERTOS_ERROR';
